import env from './env';

const node_env = process.env.NODE_ENV || "development";
const envData = {
    name: node_env,
    ...env[node_env]
}

export default envData;
